var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBox',{attrs:{"data-cy":"text-tile"}},[_c('OmtTypography',{attrs:{"as":_vm.as,"mb":"4px","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('OmtTypography',{attrs:{"as":"p1"}},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }